// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignupModal-signUpModalContainer-Woute {
    max-width: 466px;
}`, "",{"version":3,"sources":["webpack://./src/components/SignupModal/SignupModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB","sourcesContent":[".signUpModalContainer {\n    max-width: 466px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signUpModalContainer": `SignupModal-signUpModalContainer-Woute`
};
module.exports = ___CSS_LOADER_EXPORT___;
